@if (meteredElement) {
  <app-tabs>
    <app-tab [title]="'settlement.view.details'">
      <app-value-details
        [collection]="detailMasterdata"
        [data]="meteredElement"
      ></app-value-details>
    </app-tab>
    <app-tab [title]="'settlement.view.data'">
      <app-table
        [config]="tableConfig"
        [data]="tableData">
      </app-table>
    </app-tab>
    <app-tab [title]="'settlement.view.request'">
      {{ meteredElement.rsmTextRequest ?? '-' }}
    </app-tab>
    <app-tab [title]="'settlement.view.answer'">
      {{ meteredElement.rsmTextResponse ?? '-' }}
    </app-tab>
  </app-tabs>
}

